import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        user_types: {data: [], current_page: 1, total: 0, per_page: 10},
        loading: false,
        errors: {
            data: {
                errors: {
                    name: [],
                }
            }
        },
        has_errors: false,
    },
    getters: {
        loading: state => state.loading,
        dialogVisible: state => state.dialogVisible,
        user_types: state => state.user_types,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
    },
    mutations: {
        setLoading(state, val) {
            state.loading = val
        },
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setUserTypes(state, data) {
            state.user_types = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            name: [],
                        }
                    }
                };
            }
        }
    },
    actions: {
        async openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },
        async getUserTypes({commit}, filters) {
            try {
                commit('activateLoading', 'user_type/list', {root: true});
                const response = await api.getUserTypes(filters);
                commit('setUserTypes', response);
                commit('deactivateLoading', 'user_type/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async createUserType({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                await api.createUserType(data);
                dispatch('getUserTypes', {
                    paginate: true
                })
                ElMessage.success('User Type created successfully!');
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e?.response?.data?.message);
            }
        },
        async editUserType({dispatch, commit}, data) {
            try {
                commit('setLoading', true);
                await api.editUserType(data);
                dispatch('getUserTypes', {
                    paginate: true
                });
                commit('hasErrors', false)
                ElMessage.success('Information updated successfully.');
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },

        async deleteUserType({dispatch}, data) {
            try {
                await api.deleteUserType(data);
                dispatch('getUserTypes', {
                    paginate: true
                })
                ElMessage.success("User type removed successfully.")
            } catch (e) {
                if (e.response.status === 422) {
                    ElMessage.error(e.response.data.message)
                } else {
                    ElMessage.error('Error deleting User Type');
                }
            }
        }
    }
}
